import { AxiosError } from 'axios'
import { ShowTypeError } from '../enums/show-type-error.enum'

export class ApiError extends Error {
  public readonly showError: ShowTypeError
  public readonly statusCode?: number // HTTP (si aplica)
  public readonly bizCode?: number // STATUS_CODE del backend (si aplica)
  public readonly causeRaw?: unknown

  constructor(opts: {
    message: string
    showError?: ShowTypeError
    statusCode?: number
    bizCode?: number
    causeRaw?: unknown
  }) {
    super(opts.message)
    this.name = 'ApiError'
    this.showError = opts.showError ?? ShowTypeError.TEXT
    this.statusCode = opts.statusCode
    this.bizCode = opts.bizCode
    this.causeRaw = opts.causeRaw
  }
}

export class ErrorUtil {
  static getError(error: unknown): ApiError {
    if (error instanceof ApiError) return error

    if (error instanceof AxiosError) {
      return new ApiError({ message: error.response?.data.MESSAGE, causeRaw: error })
    }

    if (error instanceof Error) {
      return new ApiError({ message: error.message, causeRaw: error })
    }

    return new ApiError({
      message: 'Ocurrió un error inesperado.',
      causeRaw: error,
    })
  }
}
